import React from "react";
import moment, { Moment } from "moment";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import { AddTipContainer, TipButtonStyled } from "../tips.styled";
import { DatePickerContainer as ShiftDatePickerContainer } from "../../../saveGig/shift/shiftForm.styled";
import { DatePickerWithLabel } from "web-apps/company/components/general/datePickerWithLabel/datePickerWithLabel.component";

export type FocusedInputShape = "startDate" | "endDate" | null;

type AddTipSectionProps = {
  startDate: Moment | null;
  endDate: Moment | null;
  currentDate: Moment;
  focusedInput: FocusedInputShape | null;
  setStartDate: (date: Moment | null) => void;
  setEndDate: (date: Moment | null) => void;
  setFocusedInput: (focused: FocusedInputShape | null) => void;
  onAddTips: () => void;
};

export const AddTipSection: React.FC<AddTipSectionProps> = (props) => {
  const { t } = useTranslation();

  const monthAnchor = props.currentDate?.toDate?.() ?? new Date();

  const handleRangeChange = (dates: Date[]) => {
    if (!dates || dates.length === 0) {
      props.setStartDate(null);
      props.setEndDate(null);
      props.setFocusedInput(null);
      return;
    }

    const anchorYear = monthAnchor.getFullYear();
    const anchorMonth = monthAnchor.getMonth();

    const withinMonth = dates
      .map((d) => {
        const x = new Date(d);
        x.setHours(0, 0, 0, 0);
        return x;
      })
      .filter(
        (d) => d.getFullYear() === anchorYear && d.getMonth() === anchorMonth
      )
      .sort((a, b) => +a - +b);

    if (withinMonth.length === 0) {
      props.setStartDate(null);
      props.setEndDate(null);
      props.setFocusedInput(null);
      return;
    }

    props.setStartDate(moment(withinMonth[0]));
    props.setEndDate(moment(withinMonth[withinMonth.length - 1]));
    props.setFocusedInput(null);
  };

  const placeholder =
    props.startDate && props.endDate
      ? `${props.startDate.format("DD/MM/YYYY")} – ${props.endDate.format(
          "DD/MM/YYYY"
        )}`
      : `${t("GigsCompany.StartDate")} – ${t("GigsCompany.EndDate")}`;

  return (
    <AddTipContainer>
      <ShiftDatePickerContainer style={{ position: "relative", zIndex: 2 }}>
        <DatePickerWithLabel
          label={t("GigsCompany.Dates")}
          placeholder={placeholder}
          allowRangePicker
          rangeOnly
          restrictToMonth={monthAnchor}
          disableNavigationOutsideMonth
          dateFormat="DD/MM/YYYY"
          value={monthAnchor}
          onRangeChange={handleRangeChange}
          onFocus={() => props.setFocusedInput("startDate")}
          onBlur={() => props.setFocusedInput(null)}
          showExcludeToggles={false}
          excludeHolidays={false}
          excludeWeekends={false}
        />
      </ShiftDatePickerContainer>

      <TipButtonStyled
        onClick={props.onAddTips}
        style={{ marginLeft: "10px", height: 50 }}
        backgroundColor={Color.ModernGreen}
        title={t("CompanyTip.EnterDatesToList")}
      >
        {t("CompanyTip.Add")}
      </TipButtonStyled>
    </AddTipContainer>
  );
};
